/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import EmailCheck from "@/src/components/EmailCheck/EmailCheck";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "@/src/components/Checkin/Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React, { ReactNode } from "react";
import { useForm } from "@/src/provider/Form/FormProvider";
import partnerCheckinStyle from "./partnerCheckinStyle";
import { emailDefault, requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";

type PartnerCheckinFormProps = {
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  isLoading: boolean;
  additionalFields?: ReactNode;
  externalError?: string;
};

export default function PartnerCheckinForm({ emailErrorText, setEmailErrorText, isLoading, additionalFields, externalError }: PartnerCheckinFormProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        {additionalFields}
        <Grid
          sx={partnerCheckinStyle.gridSpace}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <EmailCheck
            name="customer.email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
          />
        </Grid>
        <Grid size={12}> {/*no condition because this also makes sure that theres a line break before the button*/}
          <Typography color={"error"} sx={{ textAlign: "center", marginTop: "1rem"}}>{externalError}</Typography>
        </Grid>
        <Grid
          sx={[partnerCheckinStyle.submit, partnerCheckinStyle.gridTopSpaced]}
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <ButtonLoading variant="contained" color="primary" sx={partnerCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            Jetzt starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
